module.exports = __webpack_public_path__ + "6b95c9c97f5ef0140342eec0b284eb77.png";